import $ from 'jquery';
export const init = async function() {
    // on swatch click
    $('.js-coll-swatch').on('click', function() {
        const selectedColor = $(this).attr('prod-color');
        const selectedCollection = $(this).attr('smp-coll');
        // hide all slots
        $('.js-smp-slot[smp-coll="' + selectedCollection + '"]').addClass('u-hide');
        // show selected slot
        $('.js-smp-slot[smp-coll="' + selectedCollection + '"][prod-color="' + selectedColor + '"]').removeClass('u-hide');
        // deactivate swatches
        $('.js-coll-swatch[smp-coll="' + selectedCollection + '"]').removeClass('active');
        // activate swatch
        $('.js-coll-swatch[smp-coll="' + selectedCollection + '"][prod-color="' + selectedColor + '"]').addClass('active');
    });
};
